import { PrecisionNumberInput } from './PrecisionNumberInput';
import { useFieldValue } from './useFieldValue';
import type { FieldComponentProps } from '@/data/registry';

type Vec3Like = { x: number; y: number; z: number };

export function Vector3Field({
  object,
  field,
  label,
}: FieldComponentProps<Vec3Like>) {
  const value = useFieldValue(object, field);

  const updateAxis = (axis: keyof Vec3Like, raw: string) => {
    const nextAxisValue = Number.parseFloat(raw);
    if (Number.isNaN(nextAxisValue)) {
      return;
    }

    const nextValue = { ...value, [axis]: nextAxisValue };
    object.set(field, nextValue);
  };

  return (
    <label className="mt-1.5 grid grid-cols-[84px_1fr] items-center gap-2 text-[0.78rem] leading-tight">
      <span className="truncate text-[0.68rem] font-medium tracking-[0.04em] text-white/65">
        {label}
      </span>
      <span className="grid grid-cols-3 gap-1.5">
        <PrecisionNumberInput
          value={value.x}
          onChange={nextValue => updateAxis('x', nextValue.toString())}
        />
        <PrecisionNumberInput
          value={value.y}
          onChange={nextValue => updateAxis('y', nextValue.toString())}
        />
        <PrecisionNumberInput
          value={value.z}
          onChange={nextValue => updateAxis('z', nextValue.toString())}
        />
      </span>
    </label>
  );
}
